import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, BgLoader, UiInput, UiToggle, OverlayLoader, UiClientSelect, UiButton } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";


const AttendanceModal = NiceModal.create(
  ({ id, date,  note = "", data }) => {
    const [input, setInput] = useState(note);
    const [state, setState] = useState({ count: 0 });
    const [loader, showLoader] = useState(false);
    const modal = useModal();
    const zstate = useStore((state) => state.categories);
    const mstate = useStore((state) => state.machines);
    const setZState = useStore((state) => state.setGroups);
    const schema = yup.object().shape({
      type: yup.string().required("Select type"),
  

    }, []);
    const {
      register,
      handleSubmit,
      control,
      resetField,
      unregister,
      setValue,
      watch,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {
      showLoader(true);

      instance({
        method: "post",
        url: "/update_attendance",
        data: e,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          showLoader(false);
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };


    useEffect(() => {


    }, []);



    const handleHide = () => {
      modal.hide();
    }

   


    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Attendance</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={loader} />

        <BootstrapModal.Body>
          <form id="vsform" onSubmit={handleSubmit(onSubmitHandler)}>

     

            <UiSelect
              name='type'
              label="Attendance"
              required
              message={errors.type?.message}
              options={["Present", "Absent", "Half Day", "Over Time", "Holiday"]}
              {...register(`type`)}
            />
          


            <input type="hidden" value={id} name="id" {...register("id")} />
            <input type="hidden" value={date} name="date" {...register("date")} />

            <UiButton className="btn btn-primary" type="submit" title="Save"/>
          
          </form>
        </BootstrapModal.Body>


      </BootstrapModal>
    );
  }
);

export default AttendanceModal;
